(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.ajax-cart__panel');
  const itemsNode = drawer.querySelector('[data-cart-items]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const statusNode = drawer.querySelector('[data-cart-status]');
  let lastFocus = null;

  const escapeHtml = (value = '') => {
    const node = document.createElement('div');
    node.textContent = String(value);
    return node.innerHTML;
  };

  const money = (cents) => {
    const format = (window.HWBCart && window.HWBCart.moneyFormat) || '${{amount}}';
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return format
      .replace(/{{\s*amount_no_decimals\s*}}/g, String(Math.round(Number(cents || 0) / 100)))
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, amount.replace('.', ','))
      .replace(/{{\s*amount\s*}}/g, amount);
  };

  const setCount = (count) => {
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.classList.toggle('is-empty', count === 0);
    });
    const drawerCount = drawer.querySelector('[data-drawer-count]');
    if (drawerCount) drawerCount.textContent = `(${count})`;
  };

  const propertiesHtml = (properties) => Object.entries(properties || {})
    .filter(([key, value]) => value && key.charAt(0) !== '_')
    .map(([key, value]) => `<p class="ajax-cart__property">${escapeHtml(key)}: ${escapeHtml(value)}</p>`)
    .join('');

  const render = (cart) => {
    setCount(cart.item_count);
    if (!cart.items.length) {
      itemsNode.innerHTML = '<div class="ajax-cart__empty"><div><p>Your bag is empty.</p><a class="ajax-cart__continue" href="/collections/all">Continue shopping</a></div></div>';
      footer.hidden = true;
      return;
    }

    itemsNode.innerHTML = cart.items.map((item, index) => `
      <article class="ajax-cart__item" data-line="${index + 1}">
        <a href="${escapeHtml(item.url)}">
          ${item.image ? `<img class="ajax-cart__image" src="${escapeHtml(item.image)}&width=184" alt="${escapeHtml(item.product_title)}" width="92" height="112">` : ''}
        </a>
        <div>
          <a class="ajax-cart__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ajax-cart__variant">${escapeHtml(item.variant_title)}</p>` : ''}
          ${propertiesHtml(item.properties)}
          <div class="ajax-cart__qty">
            <button type="button" data-cart-minus aria-label="Decrease ${escapeHtml(item.product_title)}">−</button>
            <input type="number" min="0" value="${item.quantity}" data-cart-quantity aria-label="Quantity">
            <button type="button" data-cart-plus aria-label="Increase ${escapeHtml(item.product_title)}">+</button>
          </div>
          <button class="ajax-cart__remove" type="button" data-cart-remove>Remove</button>
        </div>
        <div class="ajax-cart__price">${money(item.final_line_price)}</div>
      </article>`).join('');

    drawer.querySelector('[data-cart-total]').innerHTML = money(cart.total_price);
    footer.hidden = false;
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load your bag.');
    return response.json();
  };

  const refresh = async () => {
    const cart = await getCart();
    render(cart);
    return cart;
  };

  const open = async () => {
    lastFocus = document.activeElement;
drawer.hidden = false;
document.body.classList.add('cart-drawer-open');

// Register the drawer's off-screen position before animating.
void panel.offsetWidth;

requestAnimationFrame(() => {
  drawer.classList.add('is-open');
});
    try { await refresh(); } catch (error) { statusNode.textContent = error.message; }
    panel.focus();
  };

  const close = () => {
    drawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(() => { drawer.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus();
  };

  const changeLine = async (line, quantity) => {
    drawer.classList.add('is-loading');
    statusNode.textContent = '';
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, Number(quantity) || 0) })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Could not update your bag.');
      render(cart);
    } catch (error) { statusNode.textContent = error.message; }
    finally { drawer.classList.remove('is-loading'); }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('.js-open-cart, [data-cart-open]');
    if (opener) { event.preventDefault(); open(); return; }
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    const item = event.target.closest('[data-line]');
    if (!item) return;
    const input = item.querySelector('[data-cart-quantity]');
    if (event.target.closest('[data-cart-minus]')) changeLine(item.dataset.line, Number(input.value) - 1);
    if (event.target.closest('[data-cart-plus]')) changeLine(item.dataset.line, Number(input.value) + 1);
    if (event.target.closest('[data-cart-remove]')) changeLine(item.dataset.line, 0);
  });

  drawer.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cart-quantity]')) return;
    changeLine(event.target.closest('[data-line]').dataset.line, event.target.value);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  document.querySelectorAll('[data-product-buy-box]').forEach((box) => {
    const form = box.querySelector('[data-product-form]');
    const quantity = form.querySelector('[name="quantity"]');
    const variantInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const errorNode = form.querySelector('[data-product-error]');
    const variants = JSON.parse(box.querySelector('[data-product-variants]').textContent);

    box.querySelector('[data-qty-minus]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    box.querySelector('[data-qty-plus]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) + 1); });

    box.querySelectorAll('[data-product-option]').forEach((option) => option.addEventListener('change', () => {
      const selected = [...box.querySelectorAll('[data-product-option]:checked')].map((input) => input.value);
      const variant = variants.find((entry) => entry.options.every((value, i) => value === selected[i]));
      if (!variant) {
        variantInput.value = '';
        button.disabled = true;
        buttonText.textContent = 'Unavailable';
        return;
      }
      variantInput.value = variant.id;
      button.disabled = !variant.available;
      buttonText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      const price = document.querySelector('.product-price');
      const compare = document.querySelector('.product-compare');
      if (price) price.innerHTML = money(variant.price);
      if (compare) {
        compare.innerHTML = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    }));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!variantInput.value || button.disabled) return;
      button.classList.add('is-loading');
      button.disabled = true;
      errorNode.hidden = true;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This item could not be added.');
        await open();
      } catch (error) {
        errorNode.textContent = error.message;
        errorNode.hidden = false;
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    });
  });

  refresh().catch(() => {});
  window.HWBCart.open = open;
  window.HWBCart.refresh = refresh;
})();

 